// extracted by mini-css-extract-plugin
export default {"slot":"toit2f","slotSelected":"xZyFWc","slotAvailable":"Iw4zo4","slotDisabled":"hERwDb"};